export enum ConfigurationType {
    provider = 'provider',
    request = 'request',
}
